import service from '@/utils/server';
let modelPath = '/mytask/mytask';
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post'
    })
};



// WEBPACK FOOTER //
// ./src/page/mytask/mytask/api/index.js